import type { FunctionComponent } from 'react'
import React from 'react'

import classnames from 'classnames'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const MobilePhoneSimIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 50,
  height = 50,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <path
        d="M12.6 1.1h20.2c1.1 0 2.2.5 3 1.3l4.6 4.9c.7.8 1.1 1.8 1.1 2.8v34.5c0 2.3-1.8 4.1-4.1 4.1H12.6c-2.3 0-4.1-1.8-4.1-4.1V5.2c0-2.3 1.8-4.1 4.1-4.1z"
        fill="#ffffff"
        className={classnames(styles.white, styles.defaultStrokeColor)}
        stroke="#000000"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <path
        d="M31.6 43.7H18.1c-2.4 0-4.3-1.9-4.3-4.3V25.8c0-2.4 1.9-4.3 4.3-4.3h13.5c2.4 0 4.3 1.9 4.3 4.3v13.5c.1 2.4-1.9 4.4-4.3 4.4z"
        fill="#E81C30"
        className={styles.accentColor}
      />
      <path
        d="M13.8 29.1H36"
        fill="none"
        className={styles.whiteStroke}
        stroke="#fffff"
        strokeMiterlimit="10"
      />
      <path
        d="M19.1 36.1H36"
        fill="none"
        className={styles.whiteStroke}
        stroke="#fffff"
        strokeLinecap="round"
        strokeMiterlimit="10"
      />
      <path
        d="M19.5 21.5v7.6M24.9 21.5v7.6M30.4 21.5v7.6M30.4 36.1v7.6M25 36.1v7.6"
        fill="none"
        className={styles.whiteStroke}
        stroke="#fffff"
        strokeMiterlimit="10"
      />
      <path
        d="M19.1 36.1v7.6"
        fill="none"
        className={styles.whiteStroke}
        stroke="#fffff"
        strokeLinecap="round"
        strokeMiterlimit="10"
      />
    </Icon>
  )
}
